export enum ChatEnum {
    mime_accept_string_img = 'image/jpeg,image/png,image/jpg,image/bmp,image/ico',
    mime_accept_string_others = 'application/pdf,application/rtf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet'
}
